
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/m/a/[id]",
      function () {
        return require("private-next-pages/m/a/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/m/a/[id]"])
      });
    }
  